import { Text } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { consts as commonConsts } from '@finley-technologies/common';

type ResponsiblePartiesProps = {
  responsibleParties: { responsibleParty: { id: string; name: string } }[];
  requestingOrganizationId: string;
};
export const ResponsibleParties = ({
  responsibleParties,
  requestingOrganizationId,
}: ResponsiblePartiesProps) => {
  const currentResponibleParties =
    responsibleParties.length > 1
      ? _.filter(
          responsibleParties,
          ({ responsibleParty: { id: currentResponsiblePartyId } }) =>
            currentResponsiblePartyId !==
            commonConsts.specialOrganizationIds.finley,
        )
      : responsibleParties;

  return (
    <>
      {_.map(
        currentResponibleParties,
        ({
          responsibleParty: {
            id: currentResponsiblePartyId,
            name: currentResponsiblePartyName,
          },
        }) => (
          <Text
            fontWeight={
              currentResponsiblePartyId === requestingOrganizationId
                ? 'bold'
                : undefined
            }
            key={currentResponsiblePartyId}
          >
            {currentResponsiblePartyName}
          </Text>
        ),
      )}
    </>
  );
};
